import ava from "../../assets/ava.webp";
import screenshotLeft from "../../assets/left.webp";
import screenshotMiddle from "../../assets/midle.webp";
import screenshotRight from "../../assets/right.webp";
import blueStar from "../../assets/starBlue.png";
import greyStar from "../../assets/starGrey.png";
import user from "../../assets/user.png";
import { useEffect, useState } from "react";
import { Reviews } from "../Reviews/Reviews";
import { New } from "../New/New";
import { Additional } from "../Additional/Additional";
import { ColorRing } from "react-loader-spinner";
import { buildOfferClickUrl } from "../../utils/offerUrl";

export const Main = ({
  handleClick,
  animating,
  setAnimating,
  megabyte,
}) => {
  const [showDescription, setShowDescription] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const isClickedInstall = localStorage.getItem("isClickedInstall");
    if (isClickedInstall) {
      localStorage.removeItem("isClickedInstall");
      const pixel = localStorage.getItem("pixel");
      const sendPixel = async () => {
        if (localStorage.getItem("pixelUsed")) {
          return;
        } else {
          // Inject Facebook pixel script
          const el = document.getElementById("pixelTagId");
          if (el) {
            /* global fbq */ // Declare fbq as a global variable
            // eslint-disable-next-line
            !(function (f, b, e, v, n, t, s) {
              if (f.fbq) return;
              n = f.fbq = function () {
                n.callMethod
                  ? n.callMethod.apply(n, arguments)
                  : n.queue.push(arguments);
              };
              if (!f._fbq) f._fbq = n;
              n.push = n;
              n.loaded = !0;
              n.version = "2.0";
              n.queue = [];
              t = b.createElement(e);
              t.async = !0;
              t.src = v;
              s = b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t, s);
            })(
              window,
              document,
              "script",
              "https://connect.facebook.net/en_US/fbevents.js"
            );
            fbq("init", pixel);
            fbq("track", "Lead");
            el.innerHTML = `<img alt='test' src=https://www.facebook.com/tr?id=${pixel}&ev=PageView&noscript=1 style=\"display:none\" width=\"1px\" height=\"1px\">`;
          }
          localStorage.setItem("pixelUsed", true);
        }
      };

      sendPixel();
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []);

  return (
    <div className="main__top">
      <div id="pixelTagId"></div>

      <main className="main">
        <div className="main__wrapper">
          <img src={ava} alt="PokerDom" className="logo" />
          <div className="main__wrap">
            <p className="main__title">PokerDom</p>
            <div className="main__tags">
              <p className="main__tag">PokerDom</p>
              <p className="main__tag">Покер</p>
              <p className="main__tag">Казино</p>
            </div>
            <p className="years">21+</p>
          </div>
          <div className="desktop__info">
            <div className="top__wrapper">
              <img src={blueStar} alt="safety" width={14} height={14} />
              <p className="top__text">Выбор редакции</p>
            </div>
            <div className="bottom__wrapper">
              <div className="greyStars__wrapper">
                <img src={greyStar} alt="grey star" width={10} height={10} />
                <img src={greyStar} alt="grey star" width={10} height={10} />
                <img src={greyStar} alt="grey star" width={10} height={10} />
                <img src={greyStar} alt="grey star" width={10} height={10} />
                <img src={greyStar} alt="grey star" width={10} height={10} />
              </div>
              <p className="bottom__text">4625</p>
              <img src={user} alt="" />
            </div>
          </div>
        </div>
        <div className="app__info">
          <ul className="app__list">
            <li className="app__item">
              <div className="app__content">
                <div className="app__wrapper">
                  <p className="app__title">4.8</p>
                  <svg
                    width={14}
                    enableBackground="new 0 0 24 24"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#f9ab00"
                  >
                    <g fill="none">
                      <path d="M0,0h24v24H0V0z"></path>
                      <path d="M0,0h24v24H0V0z"></path>
                    </g>
                    <path d="M12,17.27L18.18,21l-1.64-7.03L22,9.24l-7.19-0.61L12,2L9.19,8.63L2,9.24l5.46,4.73L5.82,21L12,17.27z"></path>
                  </svg>
                </div>
                <p className="app__description">Оценки</p>
              </div>
            </li>
            <li className="app__item">
              <div className="app__content">
                <p className="app__title">
                  <svg
                    viewBox="0 0 18 18"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    fill="#5f6368"
                  >
                    <g transform="translate(21.552 22.5) rotate(180)">
                      <path
                        transform="translate(7.552 7.652)"
                        d="M.625,0h8.75A.68.68,0,0,1,10,.723a.68.68,0,0,1-.625.723H.625A.68.68,0,0,1,0,.723.68.68,0,0,1,.625,0Z"
                        data-name="Path 288"
                      ></path>
                      <g transform="translate(17.552 20.797) rotate(180)">
                        <path
                          d="M0,0H9.666V9.666H0Z"
                          fill="none"
                          data-name="Path 289"
                        ></path>
                        <path
                          transform="translate(-4.408 -3.203)"
                          d="M8.752,4.642V11.81L5.536,8.678a.677.677,0,0,0-.936,0,.627.627,0,0,0,0,.9l4.343,4.229a.669.669,0,0,0,.929,0l4.343-4.229a.627.627,0,0,0,0-.9.669.669,0,0,0-.929,0L10.07,11.81V4.642a.659.659,0,0,0-1.318,0Z"
                          data-name="Path 290"
                        ></path>
                      </g>
                      <rect
                        transform="translate(4.552 5.5)"
                        width="16"
                        height="16"
                        rx="2"
                        fill="none"
                        stroke="#5f6368"
                        strokeWidth="2"
                        data-name="Rectangle 123"
                      ></rect>
                    </g>
                  </svg>
                </p>
                <p className="app__description">3,3 МБ</p>
              </div>
            </li>
            <li className="app__item">
              <div className="app__content">
                <p className="app__title">21+</p>
                <p className="app__description">21+</p>
              </div>
            </li>
            <li className="app__item">
              <div className="app__content">
                <p className="app__title">20794</p>
                <p className="app__description">Установок</p>
              </div>
            </li>
          </ul>
        </div>
        {animating === true ? (
          <div className="lines__wrapper">
            {megabyte === "Установка..." ? (
              <p className="megabytes">{megabyte}</p>
            ) : (
              <p className="megabytes">{megabyte} МБ / 3,3 МБ</p>
            )}
            <div className="greyLine">
              <div className="greenLine"></div>
            </div>
          </div>
        ) : animating === "done" ? (
          <div
            onClick={() => {
              localStorage.setItem("isClickedInstall", true);
            }}
          >
            <a
              href={buildOfferClickUrl()}
              target="_blank"
              rel="noopener noreferrer"
              className="main__button pwa__link"
            >
              Играть
            </a>
          </div>
        ) : (
          <button
            type="button"
            className="main__button"
            disabled={isLoading}
            onClick={() => {
              handleClick();
            }}
          >
            {isLoading ? (
              <ColorRing
                visible={true}
                height="27"
                width="27"
                ariaLabel="color-ring-loading"
                wrapperStyle={{}}
                wrapperClass="color-ring-wrapper"
                colors={["#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff"]}
              />
            ) : (
              "Установить"
            )}
          </button>
        )}
        <div className="main__thumb">
          <img
            src={screenshotLeft}
            alt="Скриншот приложения"
            height={210}
            className="main__images"
          />
          <img
            src={screenshotMiddle}
            alt="Скриншот приложения"
            height={210}
            className="main__images"
          />
          <img
            src={screenshotRight}
            alt="Скриншот приложения"
            height={210}
            className="main__images"
          />
        </div>
        <p className="main__about">Об этом приложении</p>
        <p className="main__item--one">
          PokerDom — покер и онлайн-казино в одном приложении: кэш-столы,
          турниры, топовые слоты с высоким RTP и регулярные бонусы и акции.
        </p>
        <ul
          className={
            showDescription ? "main__list" : "main__list main__list--blur"
          }
        >
          <li className="main__item">
            Надёжная площадка для покера и онлайн-казино в 2026 году!
          </li>
          {showDescription && (
            <>
              <li className="main__item">
                Мгновенный депозит и вывод средств без комиссии
              </li>
              <li className="main__item">Минимальный депозит от 100 ₽</li>
              <li className="main__item">
                Покер: кэш-столы и турниры на любой банкролл
              </li>
              <li className="main__item">
                Казино: тысячи слотов от топ-провайдеров с высоким RTP и
                понятными правилами игры
              </li>
              <li className="main__item">
                Регулярные бонусы: кэшбэк, фриспины, перезарядки и сезонные
                акции — без долгих пауз между предложениями
              </li>
              <li className="main__item">
                Частые турниры по покеру и слотам, лотереи и розыгрыши
              </li>
              <li className="main__item">Круглосуточная поддержка 24/7</li>
              <li className="main__item">
                Один из популярных покер-румов и казино в регионе!
              </li>
              <p
                className="main__item"
                style={{ marginLeft: "-15px", marginBottom: "20px" }}
              >
                Играйте в PokerDom — покер, слоты и акции с выгодными условиями!
              </p>
              <p className="main__item" style={{ marginLeft: "-15px" }}>
                Бонус для новых игроков — до 250 000 ₽!
              </p>
              <li className="main__item">
                Участие в розыгрыше призового фонда до 10 000 000 ₽!
              </li>
              <li className="main__item">
                Фрироллы и специальные серии для новичков в покере
              </li>
              <li className="main__item">
                Бонусные баллы за активность в покере и в слотах
              </li>
              <li className="main__item">
                Бонус на первый депозит 150% — действует 30 дней после
                регистрации
              </li>
            </>
          )}
        </ul>
        <button
          type="button"
          className="show__button"
          onClick={() => {
            setShowDescription((prevState) => !prevState);
          }}
        >
          {showDescription ? "Свернуть" : "Ещё"}
        </button>
        <div className="line"></div>
        <Reviews />
        <div className="line"></div>
        <New />
        <div className="line"></div>
        <Additional />
        <div className="line"></div>
      </main>
    </div>
  );
};
